import { includes, orderBy } from 'lodash';

export class SimilarPostsFactory {
  constructor (posts, currentPostSlug) {
    // Filter for legacy posts
    if (posts[0].legacyPost) {
      this.posts = posts.filter(
        (post) => post.slug !== currentPostSlug);
    } else {
    // For non-legacy posts, don't include the current post in posts list or reinvent posts
      this.posts = posts.filter(
        (post) => post.slug !== currentPostSlug && (post.category && post.category.slug !== 'reinvent'));
    }
    this.currentPostSlug = currentPostSlug;
    // Set default values
    this.maxPosts = 2;
    this.category = null;
    this.tags = [];
  }

  // Builder pattern usage
  setMaxPosts (m) {
    this.maxPosts = m;
    return this;
  }

  setCategory (category) {
    this.category = category;
    return this;
  }

  setTags (tagsArray) {
    this.tags = tagsArray;
    return this;
  }

  getPosts () {
    const { category, tags, posts, maxPosts } = this;
    // Use an Identity Map to keep track of the similarity score
    const identityMap = {};

    if (!!tags === false || tags.length === 0) {
      // Tags not provided, use setTags()
      return [];
    }

    if (!!category === false) {
      // Category not provided, use setCategory()
      return [];
    }

    function getSlug (post) {
      return post.slug;
    }

    function addToMap (post) {
      const slug = getSlug(post);
      if (!identityMap.hasOwnProperty(slug)) {
        identityMap[slug] = {
          post: post,
          points: 0
        };
      }
    }

    // For category matches, we add 2 points
    function addCategoryPoints (post, category) {
      const categoryPoints = 2;
      const slug = getSlug(post);

      if (post.category.slug === category) {
        identityMap[slug].points += categoryPoints;
      }
    }

    // For tags matches, we add 1 point
    function addTagsPoints (post, tags) {
      const tagPoint = 1;
      const slug = getSlug(post);

      if (post.legacyPost) {
        post.category.forEach((tag) => {
          if (includes(tags, tag)) {
            identityMap[slug].points += tagPoint;
          }
        });
      } else {
        post.tags.forEach((tag) => {
          if (includes(tags, tag.slug)) {
            identityMap[slug].points += tagPoint;
          }
        });
      }
    }

    function getIdentityMapAsArray () {
      return Object.keys(identityMap).map((slug) => identityMap[slug]);
    }

    // Map over all posts, add to map and add points
    for (const post of posts) {
      addToMap(post);
      addCategoryPoints(post, category);
      addTagsPoints(post, tags);
    }

    // Convert the identity map to an array
    const arrayIdentityMap = getIdentityMapAsArray();

    // Use a lodash utility function to sort them
    // by points, from greatest to least
    const similarPosts = orderBy(
      arrayIdentityMap, ['points'], ['desc']
    );

    // Squash the results now that we don't need points anymore
    const squashedSimilarPosts = similarPosts.map(post => post.post);

    // Take the max number posts requested
    return squashedSimilarPosts.splice(0, maxPosts);
  }
}

export default SimilarPostsFactory;
